import ProjectServer from "@/models/ProjectServer";
export class NodeCreateRequest 
{
    title = '';
    description = '';
    start = '';
    end = '';
    dateOptions = 0;
    image = '';
    video = '';
    imageCaption = '';
    audio = '';
    important = false;
    timelineid = 0;
    tagIds: number[] = [];
    data = '';
}

const CreateNodeRequest_RPC = "CreateNodeRequest";
export class NodeHandlers 
{
    static async CreateNodeRequest(args: NodeCreateRequest) 
    {
        console.log(args);
        return await ProjectServer.instance.AsyncRequests.SendRequest<number, NodeCreateRequest>(CreateNodeRequest_RPC, args);
    }
}